import React from 'react';
import { WeaponGroup } from '@api/disciplinesApi/interfaces';
import { Box, Typography } from '@mui/material';
import { WizardContent } from '../../components/WizardContent';
import { IConfirmationStep } from './interfaces';
import { DateField, Form, SelectField, TextField } from '@components/form-components';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ConfirmationStep: React.FC<IConfirmationStep> = ({
  value,
  shotOn,
  note,
  previewUrl,
  minShotOnDate,
  maxShotOnDate,
  selectableWeaponGroups,
  weaponGroup,
  onValueChange,
  onShotOnChange,
  onNoteChange,
  onWeaponGroupChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const showWeaponGroupField = selectableWeaponGroups.length > 1;

  return (
    <WizardContent
      text={t('competitions:portal.dialogs.submitScore.confirmation.description')}
    >
      <Box
        sx={{
          mt: '10px',
        }}
      >
        <Form>
          {showWeaponGroupField && (
            <SelectField
              name="weaponGroup"
              label={t(
                'competitions:portal.dialogs.submitScore.fields.weaponGroup'
              )}
              required
              value={weaponGroup}
              placeholder={t(
                'competitions:portal.dialogs.submitScore.fields.weaponGroup'
              )}
              onChange={(value) =>
                onWeaponGroupChange(value as WeaponGroup | '')
              }
            >
              {selectableWeaponGroups.map((group) => (
                <MenuItem key={group} value={group}>
                  {t(`competitions:weaponGroups.${group}.label`)}
                </MenuItem>
              ))}
            </SelectField>
          )}
          <TextField
            label={t('competitions:portal.dialogs.submitScore.fields.value')}
            placeholder={t('competitions:portal.dialogs.submitScore.fields.value')}
            required
            value={value}
            onChange={onValueChange}
          />
          <DateField
            onChange={onShotOnChange}
            label={t('competitions:portal.dialogs.submitScore.fields.shotOn')}
            value={shotOn}
            required
            minDate={minShotOnDate}
            maxDate={maxShotOnDate}
          />
          <TextField
            label={t('competitions:portal.dialogs.submitScore.fields.note')}
            placeholder={t(
              'competitions:portal.dialogs.submitScore.fields.notePlaceholder'
            )}
            multiline
            value={note}
            onChange={onNoteChange}
          />
        </Form>

        <Typography
          variant="body1"
          fontWeight="bold"
          fontSize="14.4px"
          color="text.secondary"
        >
          {t('competitions:portal.dialogs.submitScore.fields.scorecard')}
        </Typography>
        <img
          style={{
            width: '100%',
            border: '1px solid #b2bec3',
          }}
          src={previewUrl}
          alt={t('competitions:portal.dialogs.submitScore.fields.scorecard')}
        />
      </Box>
    </WizardContent>
  );
};
